import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from "react-redux";
import { IApplicationState, AppActionCreators, ICenterFollowUpLabOptionListResponse, CenterActionCreators, IAddUpdateFollowUpLabOptionResponse } from "@nkr/store/index";
import { Button, Modal, Table } from 'react-bootstrap';
import { IBaseResponse, ICenterFollowUpLabOption } from '@nkr/models/index';
import styled from 'styled-components';
import CenterFollowUpLabOptionsAddEdit from './add-edit';
import { IFollowUpLabOptionsData } from './follow-up-lab-options-data';
import { toast } from 'react-toastify';
import ListRow from './list-row';
import ConfirmDelete from './confirm-delete';
import { downloadFile } from '../../../services/download-file';

const TableWrapper = styled(Table)`
    & > tbody > tr > td {
        vertical-align: middle;
    }
`;

interface IProps {
    centerId: number,
    isCenter: boolean,
    clearFile: any
}

interface IStateProps {
    addFollowUpLabOption: boolean
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getFollowUpLabOptionsList: (centerId: number) => Promise<ICenterFollowUpLabOptionListResponse>,
    setAddFollowUpLabOptions: (addFollowUp: boolean) => void,
    updateFollowUpLabOptions: (id: number, isFollowUpNeeded: boolean, isLabOrdersOrPrintableLetters: boolean, optionText: string, filePath: string, followUpfile: File) => Promise<IAddUpdateFollowUpLabOptionResponse>,
    addFollowUpLabOptions: (id: number, centerId: number, isFollowUpNeeded: boolean, isLabOrdersOrPrintableLetters: boolean, optionText: string, filePath: string, followUpfile: File) => Promise<ICenterFollowUpLabOptionListResponse>,
    deleteFollowUpLabOptions: (id: number, centerId: number) => Promise<IBaseResponse>,
    uploadFollowUpFile: (id: number, centerId: number, followUpfile: File) => Promise<IBaseResponse>,
    getLabOrderPreview: (labOrderId: number, centerId: number) => Promise<any>
}



type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: ICenterFollowUpLabOption[],
    upload: File,
    dirty: boolean,
    addEdit: {
        show: boolean,
        data: IFollowUpLabOptionsData
    },
    delete: {
        show: boolean,
        data: ICenterFollowUpLabOption
    }
}

class FollowUpLabOptionsList extends React.Component<TProps, IState> {
    readonly state: IState = {
        upload: this.props.clearFile,
        list: [],
        dirty: false,
        addEdit: {
            show: false,
            data: null
        },
        delete: {
            show: false,
            data: null
        }
    }

    componentDidMount = () => {
        this.getData();
    }

    componentWillReceiveProps = (nextProps: TProps) => {
        if (nextProps.addFollowUpLabOption) {
            this.showAddEdit(0);
        }
    }

    getData = () => {
        this.props.showLoading("Getting follow up option, one moment please...").then(() => {
            Promise
                .all([
                    this.props.getFollowUpLabOptionsList(this.props.centerId)
                ])
                .then(([response]) => {
                    if (response.data.success) {
             
                        this.setState({
                            list: response.data.results
                        });
                    }

                    this.props.hideLoading();
                });
        });
    }


    showAddEdit = (id: number) => {

        let data: IFollowUpLabOptionsData = {
            id: 0,
            centerId: this.props.centerId,
            isFollowUpNeeded: false,
            isLabOrdersOrPrintableLetters: false,
            isDeleted: false,
            optionText: '',
            filePath: ''
        };

        if (id > 0) {
            let item = this.state.list.find(x => x.id == id);

            if (item != null) {

                let { id, centerId, isFollowUpNeeded, isLabOrdersOrPrintableLetters, isDeleted, optionText, filePath} = item;
                data = { id, centerId, isFollowUpNeeded, isLabOrdersOrPrintableLetters, isDeleted, optionText, filePath };
            }
        }

        this.setState({
            addEdit: {
                show: true,
                data
            }
        });
    }


    handleGetPreviewFile = (labOrderId: number, centerId: number) => {
        this.props.showLoading('Getting lab order preview, one moment please...').then(() => {
            this.props.getLabOrderPreview(labOrderId, centerId).then((response: any) => {
            downloadFile(response.data, `survey` + centerId + `.pdf`, 'application/pdf');
            this.props.hideLoading();
        });
        });
    }


    handleSelectFile = (file: File) => {
        this.setState({
            upload: file
        });
    }


    handleAddFollowUp = () => {
        this.props.setAddFollowUpLabOptions(true);
    }


    confirmDelete = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            delete: {
                show: true,
                data
            }
        });
    }


    delete = (id: number) => {
        this.props.showLoading('Deleting that followUp, one moment please...').then(() => {
            this.props.deleteFollowUpLabOptions(id, this.props.centerId).then(response => {
                if (response.data.success) {
                    let list = _.cloneDeep(this.state.list).filter(item => {
                        return item.id != id;
                    });

                    this.setState({
                        list
                    }, () => {
                        toast.success('Follow Up option deleted successfully');
                    });
                }

                this.props.hideLoading();
            });
        });
    }


    handleAction = (id: number, e: any) => {
        if (e == 'EDIT') {
            this.showAddEdit(id);
        }
        if (e == 'DELETE') {
            this.confirmDelete(id);
        }
    }

    handleAddEditChange = (data: IFollowUpLabOptionsData) => {

        this.setState({
            addEdit: { ...this.state.addEdit, data }
        });
    }

    handleSubmitAddEdit = () => {
        let { id, centerId, isFollowUpNeeded, isLabOrdersOrPrintableLetters, optionText, filePath } = this.state.addEdit.data;
        let labOrderFile = this.state.upload;

        let message = id == 0 ? 'Adding followup option, one moment please...' : 'Updating followup option, one moment please...';

        this.setState({
            addEdit: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading(message).then(() => {

                if (id == 0) {
                    this.props.addFollowUpLabOptions(id, centerId, isFollowUpNeeded, isLabOrdersOrPrintableLetters, optionText, filePath, labOrderFile).then(response => {
                        if (response.data.success) {

                            toast.success('FollowUp added successfully');

                            let list = response.data.results;
                            this.setState({ list, upload: null }, () => { this.props.setAddFollowUpLabOptions(false) });
                        }

                        this.props.hideLoading();
                    });

                } else {
                    this.props.updateFollowUpLabOptions(id, isFollowUpNeeded, isLabOrdersOrPrintableLetters, optionText, filePath, labOrderFile).then(response => {
                        if (response.data.success) {

                            toast.success('FollowUp updated successfully');

                            let list = _.cloneDeep(this.state.list).map(followup => {
                                if (followup.id == id) {
                                    return response.data.results;
                                }
                                return followup;
                            });

                            this.setState({ list, upload: null  });
                        }

                        this.props.hideLoading();
                    });
                }
            });
        });
    }


    handleSend = (labOrderId: number) => {
        this.setState({
            dirty: true
        }, () => {
                this.props.showLoading('Uploaded file, one moment please...').then(() => {
                    this.props.uploadFollowUpFile(labOrderId, this.props.centerId, this.state.upload).then(response => {

                        if (response.data.success) {

                            this.setState({
                                upload: null
                            });

                            toast.success('File Uploaded Successfully');
                        } else {
                            toast.error('Could not upload the File');
                        }

                        this.props.hideLoading();

                    });
                });
            
        });
    }

    handleCancelAddEdit = () => {
        this.setState({
            upload: null,
            addEdit: {
                show: false,
                data: null
            }
        }, () => {
            this.props.setAddFollowUpLabOptions(false);
        });
    }

    handleSubmitDelete = () => {
        let id = this.state.delete.data.id;

        this.setState({
            delete: {
                show: false,
                data: null
            }
        }, () => {
            this.delete(id);
        });
    }

    handleCancelDelete = () => {
        this.setState({
            delete: {
                show: false,
                data: null
            }
        });
    }

    render = () => {
        return (
            <>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'right', marginLeft: 'auto' }}>
                        <Button bsStyle='success' onClick={this.handleAddFollowUp}>Add Follow Up Lab Option</Button>
                    </div>
                </div>
                <TableWrapper condensed striped>
                    <thead>
                        <tr>
                            <th>Lab Option</th>
                            <th>Notify Center</th>
                            <th>Upload File</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list.map((followUpOption, index) =>
                            <ListRow
                                key={'cr-' + index}
                                followUpOption={followUpOption}
                                onAction={this.handleAction}
                                onPreviewFile={this.handleGetPreviewFile}
                            />
                        )}
                    </tbody>
                </TableWrapper>

                <CenterFollowUpLabOptionsAddEdit
                    show={this.state.addEdit.show}
                    data={this.state.addEdit.data}
                    upload={this.state.upload }
                    onFileSelect={this.handleSelectFile}
                    onUploadFile={this.handleSend}
                    onChange={this.handleAddEditChange}
                    onSubmit={this.handleSubmitAddEdit}
                    onCancel={this.handleCancelAddEdit}
                />

                <ConfirmDelete
                    show={this.state.delete.show}
                    data={this.state.delete.data}
                    onYes={this.handleSubmitDelete}
                    onNo={this.handleCancelDelete}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        addFollowUpLabOption: state.centers.addFollowUpLabOption
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getFollowUpLabOptionsList: (centerId) => {
            return dispatch(CenterActionCreators.getCenterFollowUpLabOptions(centerId));
        },
        setAddFollowUpLabOptions: (addFollowUpLabOption) => {
            return dispatch(CenterActionCreators.setAddFollowUpLabOptions(addFollowUpLabOption));
        },
        updateFollowUpLabOptions: (id, isFollowUpNeeded, isLabOrdersOrPrintableLetters, optionText, filePath, followUpfile) => {
            return dispatch(CenterActionCreators.updateCenterFollowUpLabOptions(id, isFollowUpNeeded, isLabOrdersOrPrintableLetters, optionText, filePath, followUpfile));
        },
        addFollowUpLabOptions: (id, centerId, isFollowUpNeeded, isLabOrdersOrPrintableLetters, optionText, filePath, followUpfile) => {
            return dispatch(CenterActionCreators.addCenterFollowUpLabOptions(id, centerId, isFollowUpNeeded, isLabOrdersOrPrintableLetters, optionText, filePath, followUpfile));
        },
        deleteFollowUpLabOptions: (id, centerId) => {
            return dispatch(CenterActionCreators.deleteCenterFollowUpLabOptions(id, centerId));
        },
        uploadFollowUpFile: (id, centerId, followUpfile) => {
            return dispatch(CenterActionCreators.uploadFollowUpFile(id, centerId, followUpfile));
        },
        getLabOrderPreview: (labOrderId, centerId) => {
            return dispatch(CenterActionCreators.getLabOrderPreview(labOrderId, centerId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(FollowUpLabOptionsList)